import {
  GET_UPC_REPORT_REQUEST,
  GET_UPC_REPORT_SUCCESS,
  GET_UPC_REPORT_ERROR
} from "../actions/types";

export const upcReport = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_UPC_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_UPC_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_UPC_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
